import React from 'react';
import { Control } from 'react-redux-form';
import { PendingButton } from 'components/common';

export const SubmitButton = ({
  model = 'local',
  disableInvalid = false,
  children,
  ...props
}) => {
  return (
    <Control.custom
      model={model}
      component={PendingButton}
      mapProps={{
        disabled: disableInvalid ? props => props.fieldValue.valid : undefined,
        pending: props => props.fieldValue.pending
      }}
      color="primary"
      {...props}
    >
      {children}
    </Control.custom>
  );
};

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/common/Forms/SubmitButton.jsx